/**
 * L'**unico** costruttore del link pubblico (D5, AC25). Prima l'header lo
 * componeva con `VITE_PUBLIC_APP_URL` e l'id, la sheet con `window.origin` e
 * l'id, il badge con un terzo template: tre verità che potevano divergere. Da
 * qui in poi ogni superficie che *genera* un link passa da questo modulo, e
 * `grep -rn '/profile/${' src` deve trovare solo questo file (gate di T15).
 *
 * L'origine è quella corrente e non una variabile d'ambiente: il link che si
 * copia da staging deve aprire staging, non la produzione.
 */
export type ReadyProfileLink = {
  kind: "ready";
  /** URL completo, quello che finisce negli appunti. */
  url: string;
  /** Senza protocollo: quello che si legge a schermo. */
  displayUrl: string;
  /** Il segmento finale, che il display non deve mai troncare per primo. */
  username: string;
};

/**
 * `missing` esiste perché `username` è nullo per dato storico (A7): senza
 * questo ramo ogni chiamante avrebbe costruito `/profile/null` e il
 * compilatore non avrebbe detto niente.
 */
export type ProfileLink = ReadyProfileLink | { kind: "missing" };

/**
 * Il percorso interno, per i `<A href>` che restano dentro l'app. Sta qui e
 * non nei componenti perché il link pubblico deve avere **un solo**
 * costruttore: è la condizione che il gate di T15 verifica con un grep.
 */
export const publicProfilePath = (profile: {
  id: string;
  username: string | null;
}): string => `/profile/${profile.username ?? profile.id}`;

const buildReadyLink = (username: string): ReadyProfileLink => ({
  kind: "ready",
  url: `${window.location.origin}${publicProfilePath({ id: username, username })}`,
  displayUrl: `${window.location.host}${publicProfilePath({ id: username, username })}`,
  username,
});

export const publicProfileLink = (username: string | null): ProfileLink =>
  username === null || username === ""
    ? { kind: "missing" }
    : buildReadyLink(username);

/**
 * Per le superfici che mostrano il profilo di **qualcun altro** (sheet della
 * ricerca attiva, badge del referral, chip delle raccomandazioni): lo username
 * quando c'è, altrimenti l'id, che il backend continua ad accettare in
 * ingresso (AC3). Non esiste il caso «nessun link».
 */
export const publicProfileLinkOrId = (profile: {
  id: string;
  username: string | null;
}): ReadyProfileLink => buildReadyLink(profile.username ?? profile.id);
